import { Box, Grid, Tab, Tabs, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import { useParams } from 'react-router-dom';

import {
  getMyProfile,
  getUserEdit,
  getUsersInfo,
} from '../../../packages/common/api';
import Competencies from '../../../packages/common/shared-ui/src/components/Competencies/Competencies';
import { ButtonsTypes } from '../../../packages/common/shared-ui/src/enums/commonEnums';
import { formatFields } from '../../../packages/common/utils/fieldHelper';
import { useTranslation } from '../../../packages/common/utils/getLocalString';
import CommonPage from '../CommonPage/CommonPage';

import UserPageCommonTab from './components/UserPageCommonTab/UserPageCommonTab';
import UserPageCompetencyTab from './components/UserPageCompetencyTab/UserPageRatesTab';

// Original class: userTabs
const StyledUserTabs = styled(Tabs)(theme => ({
  '&.MuiTabs-root': {
    minHeight: 'auto',
  },

  '& .MuiButtonBase-root.MuiTab-root': {
    color: '#656985',
    fontSize: '14px',
    lineHeight: '20px',
    fontWeight: '400',
    padding: '8px 16px',
    textTransform: 'capitalize',
    borderRadius: '16px 0 0 16px',
    backgroundColor: '#DCDFF4',
    minHeight: 'auto',
    minWidth: '79px',
    '& + .MuiButtonBase-root.MuiTab-root': {
      borderRadius: '0 16px 16px 0',
      marginLeft: '2px',
    },
    '& + .MuiButtonBase-root.MuiTab-root + .MuiButtonBase-root.MuiTab-root': {
      borderRadius: '0 16px 16px 0',
      marginLeft: '2px',
    },

    '&.Mui-selected': {
      backgroundColor: '#6270D0',
      color: '#fff',
    },
  },
}));

const MyPage = () => {
  const getLocalString = useTranslation();
  const currentUser = useSelector(state => state.user.info);
  const PageState = { VIEW: 'view', EDIT: 'edit' };
  const tabsNames = { COMMON: 0, RATES: 1 };
  const params = useParams();
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState(tabsNames.COMMON);
  const [userLogin, setUserLogin] = useState(null);
  const [isEdit, setIsEdit] = useState(false);
  const [pageState, setPageState] = useState(PageState.VIEW);
  const [allFields, setAllFields] = useState([]);
  const [saveEvent, setSaveEvent] = useState(false);
  const navigate = useNavigate();
  const childRef = useRef();
  const formState = useRef(
    new Map([
      [PageState.VIEW, { getResponse: getUsersInfo }],
      [PageState.EDIT, { getResponse: getUserEdit }],
    ]),
  );

  function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;
    return (
      <div role='tabpanel' {...other}>
        {value === index && <Box>{children}</Box>}
      </div>
    );
  }

  useEffect(() => {
    let ignore = false;
    async function getInfo() {
      const { data: userInfoValue } = await getMyProfile();
      if (!ignore) {
        return userInfoValue.standards;
      }
    }
    getInfo()
      .then(res => {
        let fields;
        setAllFields(res);
        setLoading(false);
      })
      .catch(error => console.error(error, 'ERROR IN GET USER INFO'));
    return () => {
      ignore = true;
    };
  }, [PageState.EDIT, PageState.VIEW, pageState, params.id, currentUser]);
  useEffect(() => {
    if (allFields.length > 0) {
      const login = allFields.find(item => item.fieldId === 'login');
      login !== undefined && setUserLogin(login.valueId);
    }
  }, [allFields]);
  const handleButtonEvent = useCallback(
    type => {
      switch (type) {
        case ButtonsTypes.EDIT_USER:
          window.open(`/my/${params.id}/edit`, '_self');
          break;
        case ButtonsTypes.SAVE:
          childRef.current.save();
          break;
        case ButtonsTypes.CANCEL:
          window.open(`/my/${params.id}`, '_self');
          break;
      }
    },
    [params.id],
  );

  return (
    <CommonPage
      buttonEvent={handleButtonEvent}
      component={'AdminUserPage'}
      loading={loading}
      state={pageState}
    >
      <Grid
        container
        sx={{
          justifyContent: 'space-between',
          alignItems: 'center',
          marginTop: '20px',
        }}
      >
        <Grid>
          <StyledUserTabs
            value={activeTab}
            onChange={(event, newValue) => setActiveTab(newValue)}
            slotProps={{
              indicator: { sx: { display: 'none' } },
            }}
          >
            <Tab label={getLocalString('AdminUserPage', 'labels', 'common')} />
            <Tab
              label={getLocalString('AdminUserPage', 'labels', 'competence')}
            />
          </StyledUserTabs>
        </Grid>
      </Grid>
      <CustomTabPanel value={activeTab} index={0}>
        <UserPageCommonTab
          fields={allFields}
          state={pageState}
          ref={childRef}
        ></UserPageCommonTab>
      </CustomTabPanel>
      <CustomTabPanel value={activeTab} index={1}>
        <Competencies
          componentMode={'view'}
          userId={currentUser.redmineId}
        ></Competencies>
      </CustomTabPanel>
    </CommonPage>
  );
};

export default MyPage;
